import { SecondaryButtonLink } from 'approot/shared/styles/buttons/secondary-button.style';
import { PStyled } from 'approot/shared/styles/typography.style';
import SimpleModal from 'lib/modal/simple-modal';
import {
  SimpleModalContentStyled,
  SimpleModalVerticalActionsStyled,
} from 'lib/modal/simple-modal.styles';

const ActivitiesEditPermissionWarning = ({
  presentUrl,
  onClose,
}: {
  presentUrl: string;
  onClose: () => void;
}) => {
  return (
    <SimpleModal isVisible title="Edit" headerTitle="Edit" onClose={onClose}>
      <SimpleModalContentStyled>
        <PStyled>
          <strong>
            You do not have permission to edit published activities.{' '}
          </strong>
        </PStyled>
        <PStyled marginBottom={0}>
          Only users with the role Activity Editor or Publisher can complete
          this action.{' '}
        </PStyled>
        <SimpleModalVerticalActionsStyled>
          <SecondaryButtonLink
            to={presentUrl}
            data-selector="btn-view-activities-only"
          >
            View Activities Only
          </SecondaryButtonLink>
        </SimpleModalVerticalActionsStyled>
      </SimpleModalContentStyled>
    </SimpleModal>
  );
};

export default ActivitiesEditPermissionWarning;
